import React from "react";
import UiTopInputElementsWr from "../common/UiTopInputElementsWr";
import DownArrow from "../../../../styles/img/down-arrow.png";
import Select, { components } from "react-select";
import PropTypes from "prop-types";

export default function UiTopSelect(props) {

    const DropdownIndicator = (props) => {
        return (
            <components.DropdownIndicator {...props}>
                <img src={DownArrow} />
            </components.DropdownIndicator>
        );
    };
    const colorStyles = {
        placeholder: (defaultStyles) => {
            return {
                ...defaultStyles,
                color: "#B1B5C3",
            };
        },
    };

    return (
        <>
            <UiTopInputElementsWr>
                {props.label && (
                    <>
                        <label htmlFor={props.label}>{props.label}</label>
                    </>
                )}
                <Select
                    onChange={props?.onChange}
                    className="basic-single"
                    classNamePrefix="select"
                    components={{ DropdownIndicator }}
                    styles={colorStyles}
                    placeholder={props.placeholder}
                    options={props.selectOptions}
                    defaultValue={props.defaultValue}
                />
            </UiTopInputElementsWr>
        </>
    );
}

UiTopSelect.propTypes = {
    label: PropTypes.string,
};
